export const TRADE_LIMITS = {
  ANONYMOUS_DAILY_USD: 250,
  PHONE_DAILY_USD: 1000,
  FFIO_THRESHOLD_USD: 150, // below this → ff.io, above → own wallet
} as const;

// Time window during which an expired order can be reopened ("Continue
// sending"). Measured from `createdAt` (NOT `expiresAt`) so chained reopens
// can't extend the window indefinitely. The 5-minute grace absorbs clock
// skew and the user-clicks-at-23:59m race.
export const REOPEN_MAX_AGE_MS = 24 * 60 * 60 * 1000 + 5 * 60 * 1000;

// Cold-start fallback when no preference exists (no User.countryCode, no
// localStorage cookie, no IP detection). Every entry point should prefer
// the user's actual selection — this is purely the "first time, no signal"
// default. Easy to flip later for region-specific deployments.
export const DEFAULT_COUNTRY = "NG";
